import { render } from "./ImageForm.vue?vue&type=template&id=3114408a&scoped=true&ts=true"
import script from "./ImageForm.vue?vue&type=script&lang=ts"
export * from "./ImageForm.vue?vue&type=script&lang=ts"

import "./ImageForm.vue?vue&type=style&index=0&id=3114408a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3114408a"]])

export default __exports__